import { gql } from '@apollo/client';

const LOG_OUT = gql`
  mutation LogoutMutation {
    logOutUser {
      errors
      success
    }
  }
`;
const REGISTER_ACCOUNT = gql`
  mutation register(
    $username: String!
    $email: String!
    $password1: String!
    $password2: String!
    $firstName: String!
    $lastName: String!
    $dateOfBirth: Date!
  ) {
    register(
      username: $username
      email: $email
      password1: $password1
      password2: $password2
      firstName: $firstName
      lastName: $lastName
      dateOfBirth: $dateOfBirth
    ) {
      success
      errors
      __typename
    }
  }
`;

const RESEND_ACTIVATION_EMAIL = gql`
  mutation resendActivationEmail($email: String!) {
    resendActivationEmail(email: $email) {
      success
      errors
    }
  }
`;

const RESET_PASSWORD_REQUEST = gql`
  mutation sendPasswordResetEmail($email: String!) {
    sendPasswordResetEmail(email: $email) {
      success
      errors
    }
  }
`;

const PASSWORD_RESET = gql`
  mutation PasswordReset(
    $newPassword1: String!
    $newPassword2: String!
    $token: String!
  ) {
    passwordReset(
      newPassword1: $newPassword1
      newPassword2: $newPassword2
      token: $token
    ) {
      errors
      success
    }
  }
`;

const CHANGE_PASSWORD = gql`
  mutation ChangePassword(
    $oldPassword: String!
    $newPassword1: String!
    $newPassword2: String!
  ) {
    changePassword(
      oldPassword: $oldPassword
      newPassword1: $newPassword1
      newPassword2: $newPassword2
    ) {
      errors
      success
    }
  }
`;

const SBU_AUTH = gql`
  mutation SbuAuth($username: String!, $password: String!) {
    sbuAuth(password: $password, username: $username) {
      success
      errors
      messageCount
      refreshToken {
        created
        expiresAt
        isExpired
        revoked
        token
      }
      token {
        token
        payload {
          exp
          origIat
          uict
        }
      }
      sbuUser {
        id
        themePref
        tzPref
        user {
          username
          verified
          isStaff
          isHost
          isActive
          profileImageUrl
          firstName
          lastName
        }
        familySettings {
          messagingActive
          hideBilling
          familyMessaging
          guardianAccount
          connectionApproval
          guardianSchedule
          userCanUpdate
        }
      }
    }
  }
`;

const WEB_AUTH = gql`
  mutation MyAuth($password: String!, $username: String!) {
    myAuth(password: $password, username: $username) {
      errors
      success
      refreshToken {
        created
        expiresAt
        isExpired
        revoked
        token
      }
      token {
        token
        payload {
          exp
          origIat
          uict
        }
      }
      user {
        uict
        username
        email
        verified
        isStaff
        isHost
        archived
        isActive
      }
    }
  }
`;

const VERIFY_ACCOUNT = gql`
  mutation verifyAccount($token: String!) {
    verifyAccount(token: $token) {
      success
      errors
    }
  }
`;

const DECLINE_INVITATION = gql`
  mutation DeclineInvitation(
    $category: String!
    $token: String!
    $rejectInvitaion: Boolean! = true
  ) {
    declineInvitation(
      category: $category
      token: $token
      rejectInvitation: $rejectInvitaion
    ) {
      errors
      success
    }
  }
`;

const REDEEM_NEW_USER_INVITATION = gql`
  mutation RedeemNewUserInvitation(
    $token: String!
    $category: String!
    $email: String!
    $firstName: String!
    $lastName: String!
    $password1: String!
    $password2: String!
    $username: String!
  ) {
    redeemNewUserInvitation(
      category: $category
      token: $token
      registerNew: {
        password1: $password1
        password2: $password2
        firstName: $firstName
        lastName: $lastName
        username: $username
        email: $email
      }
    ) {
      errors
      success
      messageCount
      refreshToken {
        created
        expiresAt
        isExpired
        revoked
        token
      }
      token {
        token
        payload {
          exp
          origIat
          uict
        }
      }
      sbuUser {
        id
        themePref
        tzPref
        user {
          username
          verified
          isStaff
          isHost
          isActive
          profileImageUrl
          firstName
          lastName
        }
        familySettings {
          messagingActive
          hideBilling
          familyMessaging
          guardianAccount
          connectionApproval
          guardianSchedule
          userCanUpdate
        }
      }
    }
  }
`;
const REDEEM_INVITATION = gql`
  mutation RedeemInvitationMutation(
    $token: String!
    $category: String!
    $email: String!
    $firstName: String!
    $lastName: String!
    $password1: String!
    $password2: String!
    $username: String!
    $timezone: String
    $existingPassword: String!
    $rejectInvitation: Boolean!
    $newUser: Boolean
  ) {
    redeemUserInvitation(
      category: $category
      token: $token
      newUser: $newUser
      registerNew: {
        password1: $password1
        password2: $password2
        firstName: $firstName
        lastName: $lastName
        username: $username
        email: $email
      }
      timezone: $timezone
      signIn: { username: $username, password: $existingPassword }
      rejectInvitation: $rejectInvitation
    ) {
      errors
      success
      messageCount
      refreshToken {
        created
        expiresAt
        isExpired
        revoked
        token
      }
      token {
        token
        payload {
          exp
          origIat
          uict
        }
      }
      sbuUser {
        id
        themePref
        tzPref
        user {
          username
          verified
          isStaff
          isHost
          isActive
          firstName
          lastName
        }
        familySettings {
          messagingActive
          hideBilling
          familyMessaging
          guardianAccount
          connectionApproval
          guardianSchedule
          userCanUpdate
        }
      }
    }
  }
`;
export {
  LOG_OUT,
  REGISTER_ACCOUNT,
  REDEEM_INVITATION,
  REDEEM_NEW_USER_INVITATION,
  RESEND_ACTIVATION_EMAIL,
  RESET_PASSWORD_REQUEST,
  PASSWORD_RESET,
  CHANGE_PASSWORD,
  VERIFY_ACCOUNT,
  WEB_AUTH,
  SBU_AUTH,
  DECLINE_INVITATION,
};
